'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useSession } from '@marketplace-web/shared/session'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { AppButton } from '@marketplace-web/domain/web-to-app'

import { IMAGE_BASE_URL } from '../constants'

type Step = {
  imageName: string
  titleKey: string
  descriptionKey: string
}

const STEPS: Array<Step> = [
  {
    imageName: 'step_1',
    titleKey: 'step_1.title',
    descriptionKey: 'step_1.description',
  },
  {
    imageName: 'step_2',
    titleKey: 'step_2.title',
    descriptionKey: 'step_2.description',
  },
  {
    imageName: 'step_3',
    titleKey: 'step_3.title',
    descriptionKey: 'step_3.description',
  },
] as const

const HowItWorksSection = () => {
  const translate = useTranslate('business.digital_product_passport.how_it_works')
  const { isWebview } = useSession()

  const renderSteps = () => {
    return STEPS.map((step, index) => {
      return (
        <div key={index} className="digital-product-passport_step">
          <Image
            src={`${IMAGE_BASE_URL}/${step.imageName}.png`}
            srcset={`${IMAGE_BASE_URL}/${step.imageName}.png 1x, ${IMAGE_BASE_URL}/${step.imageName}@2x.png 2x, ${IMAGE_BASE_URL}/${step.imageName}@3x.png 3x`}
            alt={translate(step.titleKey)}
          />
          <Text as="h3">{translate(step.titleKey)}</Text>
          <Text as="p">{translate(step.descriptionKey)}</Text>
        </div>
      )
    })
  }

  return (
    <section className="digital-product-passport_how-it-works-section">
      <div className="digital-product-passport_container">
        <Text as="h2">{translate('title')}</Text>
        <div className="digital-product-passport_steps">{renderSteps()}</div>
        {!isWebview && (
          <div className="digital-product-passport_app">
            <div className="digital-product-passport_title">
              <Text as="p">{translate('app_download_title')}</Text>
            </div>
            <div className="digital-product-passport_app-buttons">
              <AppButton platform={AppButton.Platform.Ios} />
              <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.Large} />
              <AppButton platform={AppButton.Platform.Android} />
            </div>
            <div className="digital-product-passport_privacy-policy">
              <Text as="p" html text={translate('privacy_policy_notice')} />
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default HowItWorksSection
